module.exports = __webpack_public_path__ + "img/5s.92f50e78.png";